import { Injectable } from '@angular/core';

@Injectable()
export class AppGlobals {
    readonly weburl: string = "https://blocdrivesaas.in";
    readonly usrmurl: string = "https://blocdrivesaas.in/blocdrivesaasapi";
    readonly dmsurl: string = "https://blocdrivesaas.in/blocdrivesaasapi";
   // readonly APIURL: string = "https://capadditum.com/capadditumapi/api/";   
    readonly ANAURL: string = "http://localhost:19211/api/";  
    // readonly weburl: string = "https://blocdrivesaas.in";
    // readonly usrmurl: string = "http://localhost:44319";
    // readonly dmsurl: string = "http://localhost:45320";
}